import{useState,useEffect}from'react'
import{supabase}from'./supabase'

export default function useOrg(userId){
const[orgId,setOrgId]=useState(null)
const[plan,setPlan]=useState('free')
const[loading,setLoading]=useState(true)

useEffect(()=>{
if(!userId)return
async function fetchOrg(){
const{data:member}=await supabase
.from('org_members')
.select('org_id')
.eq('user_id',userId)
.single()
if(member){
setOrgId(member.org_id)
const{data:org}=await supabase
.from('organizations')
.select('plan')
.eq('id',member.org_id)
.single()
if(org)setPlan(org.plan||'free')
}
setLoading(false)}
fetchOrg()
},[userId])

return{orgId,plan,loading}}